export default "__VITE_ASSET__CDceky6i__"